function setCookie(name, value, days = 1, path = '/') {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${encodeURIComponent(name)}=${value}; expires=${expires}; path=${path}`;
}

function deleteCookie(name, path = '/') {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
}

window.setTitle = function(t) {
    if(t == false || t == undefined) {
        console.log('Custom title deleted. Refresh the page to clear the title.')
        deleteCookie('custom-title');
    } else {
        console.log('Custom title set to:', t, '\n\nRefresh the page to see the title.\n\nDelete the custom title with: window.setTitle()' )
        setCookie('custom-title', t);
    }
}
